import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const redirect = sessionStorage.getItem("postLoginRedirect");
      if (redirect && res.user.role !== "admin") { sessionStorage.removeItem("postLoginRedirect"); navigate(redirect); }
      else navigate(res.user.role === "admin" ? "/admin" : from);
    }
    else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] sm:min-h-[calc(100vh-5rem)] lg:min-h-[calc(100vh-6rem)] flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md border border-zinc-900 bg-white shadow-[8px_8px_0px_0px_rgba(10,10,10,1)] p-8">
        <img
          src="/brandbloom-logo.png"
          alt="Brand Bloom"
          className="h-14 w-auto object-contain mx-auto mb-6"
          data-testid="login-logo"
        />
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Welcome back</span>
        <h1 className="mt-2 font-display font-black text-3xl tracking-tighter">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest">Email</Label>
            <Input
              type="email"
              required
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 rounded-none border-zinc-300 focus-visible:ring-primary"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <Label className="font-mono text-xs uppercase tracking-widest">Password</Label>
            <Input
              type="password"
              required
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 rounded-none border-zinc-300 focus-visible:ring-primary"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-destructive font-medium">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full rounded-none bg-primary hover:bg-[#5E1F92] text-white font-mono uppercase tracking-widest h-11"
          >
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-zinc-600">
          No account?{" "}
          <Link to="/register" data-testid="login-to-register" className="text-primary font-semibold hover:underline">
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}
